module.exports = __webpack_public_path__ + "0299c0a8876ed7efbdaa607a013d4027.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/year-in-review/2018/midyear/icons/activity.png
// module id = 1877
// module chunks = 1